var _excluded = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"],
  _excluded2 = ["height", "h"],
  _excluded3 = ["innerRef", "isDisabled", "isHidden", "inputClassName"],
  _excluded4 = ["data"],
  _excluded5 = ["components", "theme", "size", "colorScheme", "isDisabled", "isInvalid", "isReadOnly", "required", "isRequired", "inputId", "tagVariant", "selectedOptionStyle", "selectedOptionColorScheme", "selectedOptionColor", "variant", "focusBorderColor", "errorBorderColor", "chakraStyles", "onFocus", "onBlur", "menuIsOpen"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { forwardRef } from 'react';
import ot__default from 'react-select';
export * from 'react-select';
import { useFormControl } from '@chakra-ui/form-control';
import { useTheme, useMultiStyleConfig, useStyleConfig, useColorModeValue, chakra } from '@chakra-ui/system';
import { Box, Divider } from '@chakra-ui/layout';
import { useBreakpointValue } from '@chakra-ui/media-query';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '@chakra-ui/icon';
import { Spinner } from '@chakra-ui/spinner';
import { MenuIcon, Menu } from '@chakra-ui/menu';
import at from 'react-select/creatable';
export { useCreatable } from 'react-select/creatable';
import dt from 'react-select/async';
export { useAsync } from 'react-select/async';
import Ot from 'react-select/async-creatable';
var V = function V(e) {
    var r = e.className,
      o = e.clearValue,
      n = e.cx,
      s = e.getStyles,
      t = e.getClassNames,
      a = e.getValue,
      i = e.hasValue,
      p = e.isMulti,
      l = e.isRtl,
      c = e.options,
      d = e.selectOption,
      m = e.selectProps,
      f = e.setValue,
      x = e.theme,
      u = _objectWithoutProperties(e, _excluded);
    return _objectSpread({}, u);
  },
  Pe = function Pe(e) {
    return typeof e == "string" && ["sm", "md", "lg"].includes(e);
  },
  ge = function ge(e) {
    return Pe(e) ? e : e === "xs" ? "sm" : e === "xl" ? "lg" : "md";
  },
  O = function O(e) {
    var r = useTheme(),
      o = ge(r.components.Input.defaultProps.size),
      n = e != null ? e : o;
    return useBreakpointValue(typeof n == "string" ? [n] : n, {
      fallback: "md"
    }) || o;
  };
var W = function W(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.innerProps,
      t = e.isDisabled,
      a = e.isRtl,
      i = e.hasValue,
      p = e.selectProps.chakraStyles,
      l = _objectSpread({
        position: "relative",
        direction: a ? "rtl" : void 0
      }, t ? {
        cursor: "not-allowed"
      } : {}),
      c = p != null && p.container ? p.container(l, e) : l;
    return jsx(Box, _objectSpread(_objectSpread({}, s), {}, {
      className: n({
        "--is-disabled": t,
        "--is-rtl": a,
        "--has-value": i
      }, o),
      sx: c,
      children: r
    }));
  },
  Y = function Y(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.isMulti,
      t = e.hasValue,
      a = e.innerProps,
      _e$selectProps = e.selectProps,
      i = _e$selectProps.chakraStyles,
      p = _e$selectProps.size,
      l = _e$selectProps.variant,
      c = _e$selectProps.focusBorderColor,
      d = _e$selectProps.errorBorderColor,
      m = _e$selectProps.controlShouldRenderValue,
      f = O(p),
      x = useMultiStyleConfig("Input", {
        size: f,
        variant: l,
        focusBorderColor: c,
        errorBorderColor: d
      }),
      u = {
        display: s && t && m ? "flex" : "grid",
        alignItems: "center",
        flex: 1,
        paddingY: "2px",
        paddingX: x.field.px,
        flexWrap: "wrap",
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
      },
      S = i != null && i.valueContainer ? i.valueContainer(u, e) : u;
    return jsx(Box, _objectSpread(_objectSpread({}, a), {}, {
      className: n({
        "value-container": !0,
        "value-container--is-multi": s,
        "value-container--has-value": t
      }, o),
      sx: S,
      children: r
    }));
  },
  _ = function _(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.innerProps,
      t = e.selectProps.chakraStyles,
      a = {
        display: "flex",
        alignItems: "center",
        alignSelf: "stretch",
        flexShrink: 0
      },
      i = t != null && t.indicatorsContainer ? t.indicatorsContainer(a, e) : a;
    return jsx(Box, _objectSpread(_objectSpread({}, s), {}, {
      className: n({
        indicators: !0
      }, o),
      sx: i,
      children: r
    }));
  };
var he = function he(e) {
    var r = e.className,
      o = e.cx,
      n = e.children,
      s = e.innerRef,
      t = e.innerProps,
      a = e.isDisabled,
      i = e.isFocused,
      p = e.menuIsOpen,
      _e$selectProps2 = e.selectProps,
      l = _e$selectProps2.chakraStyles,
      c = _e$selectProps2.size,
      d = _e$selectProps2.variant,
      m = _e$selectProps2.focusBorderColor,
      f = _e$selectProps2.errorBorderColor,
      x = _e$selectProps2.isInvalid,
      u = _e$selectProps2.isReadOnly,
      S = O(c),
      _useMultiStyleConfig = useMultiStyleConfig("Input", {
        size: S,
        variant: d,
        focusBorderColor: m,
        errorBorderColor: f
      }),
      _useMultiStyleConfig$ = _useMultiStyleConfig.field,
      b = _useMultiStyleConfig$.height,
      g = _useMultiStyleConfig$.h,
      I = _objectWithoutProperties(_useMultiStyleConfig$, _excluded2),
      C = _objectSpread(_objectSpread({}, I), {}, {
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        padding: 0,
        overflow: "hidden",
        height: "auto",
        minH: b || g
      }, a ? {
        pointerEvents: "none"
      } : {}),
      B = l != null && l.control ? l.control(C, e) : C;
    return jsx(Box, _objectSpread(_objectSpread({
      ref: s,
      className: o({
        control: !0,
        "control--is-disabled": a,
        "control--is-focused": i,
        "control--menu-is-open": p
      }, r),
      sx: B
    }, t), {}, {
      "data-focus": i ? !0 : void 0,
      "data-focus-visible": i ? !0 : void 0,
      "data-invalid": x ? !0 : void 0,
      "data-disabled": a ? !0 : void 0,
      "data-readonly": u ? !0 : void 0,
      children: n
    }));
  },
  Z = function Z(e) {
    var r = e.className,
      o = e.cx,
      _e$selectProps3 = e.selectProps,
      n = _e$selectProps3.chakraStyles,
      s = _e$selectProps3.useBasicStyles,
      t = _e$selectProps3.variant,
      a = _objectSpread({
        opacity: 1
      }, s || t !== "outline" ? {
        display: "none"
      } : {}),
      i = n != null && n.indicatorSeparator ? n.indicatorSeparator(a, e) : a;
    return jsx(Divider, {
      className: o({
        "indicator-separator": !0
      }, r),
      sx: i,
      orientation: "vertical"
    });
  },
  Be = function Be(e) {
    return jsx(Icon, _objectSpread(_objectSpread({
      role: "presentation",
      focusable: "false",
      "aria-hidden": "true"
    }, e), {}, {
      children: jsx("path", {
        fill: "currentColor",
        d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
      })
    }));
  },
  J = function J(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.innerProps,
      _e$selectProps4 = e.selectProps,
      t = _e$selectProps4.chakraStyles,
      a = _e$selectProps4.useBasicStyles,
      i = _e$selectProps4.size,
      p = _e$selectProps4.focusBorderColor,
      l = _e$selectProps4.errorBorderColor,
      c = _e$selectProps4.variant,
      d = O(i),
      m = useMultiStyleConfig("Input", {
        size: d,
        variant: c,
        focusBorderColor: p,
        errorBorderColor: l
      }),
      x = {
        sm: "16px",
        md: "20px",
        lg: "24px"
      }[d],
      u = _objectSpread(_objectSpread({}, m.addon), {}, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        borderRadius: 0,
        borderWidth: 0,
        fontSize: x
      }, a && {
        background: "transparent",
        padding: 0,
        width: 6,
        marginRight: 2,
        marginLeft: 1,
        cursor: "inherit"
      }),
      S = t != null && t.dropdownIndicator ? t.dropdownIndicator(u, e) : u,
      b = {
        height: "1em",
        width: "1em"
      },
      g = t != null && t.downChevron ? t.downChevron(b, e) : b;
    return jsx(Box, _objectSpread(_objectSpread({}, s), {}, {
      className: n({
        indicator: !0,
        "dropdown-indicator": !0
      }, o),
      sx: S,
      children: r || jsx(Be, {
        sx: g
      })
    }));
  },
  ve = function ve(e) {
    return jsx(Icon, _objectSpread(_objectSpread({
      focusable: "false",
      "aria-hidden": !0
    }, e), {}, {
      children: jsx("path", {
        fill: "currentColor",
        d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
      })
    }));
  },
  K = function K(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.innerProps,
      _e$selectProps5 = e.selectProps,
      t = _e$selectProps5.chakraStyles,
      a = _e$selectProps5.size,
      i = O(a),
      l = _objectSpread(_objectSpread({}, useStyleConfig("CloseButton", {
        size: i
      })), {}, {
        marginX: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        cursor: "pointer"
      }),
      c = t != null && t.clearIndicator ? t.clearIndicator(l, e) : l,
      d = {
        width: "1em",
        height: "1em"
      },
      m = t != null && t.crossIcon ? t.crossIcon(d, e) : d;
    return jsx(Box, _objectSpread(_objectSpread({
      role: "button",
      className: n({
        indicator: !0,
        "clear-indicator": !0
      }, o),
      sx: c,
      "aria-label": "Clear selected options"
    }, s), {}, {
      children: r || jsx(ve, {
        sx: m
      })
    }));
  },
  Q = function Q(e) {
    var r = e.className,
      o = e.cx,
      n = e.innerProps,
      _e$selectProps6 = e.selectProps,
      s = _e$selectProps6.chakraStyles,
      t = _e$selectProps6.size,
      a = e.color,
      i = e.emptyColor,
      p = e.speed,
      l = e.thickness,
      c = e.spinnerSize,
      d = O(t),
      f = {
        sm: "xs",
        md: "sm",
        lg: "md"
      }[d],
      x = {
        marginRight: 3
      },
      u = s != null && s.loadingIndicator ? s.loadingIndicator(x, e) : x;
    return jsx(Spinner, _objectSpread(_objectSpread({
      className: o({
        indicator: !0,
        "loading-indicator": !0
      }, r),
      sx: u
    }, n), {}, {
      size: c || f,
      color: a,
      emptyColor: i,
      speed: p,
      thickness: l
    }));
  },
  U = he;
var we = function we(e) {
    var r = e.className,
      o = e.cx,
      n = e.value,
      _e$selectProps7 = e.selectProps,
      s = _e$selectProps7.chakraStyles,
      t = _e$selectProps7.isReadOnly,
      _V = V(e),
      a = _V.innerRef,
      i = _V.isDisabled,
      p = _V.isHidden,
      l = _V.inputClassName,
      c = _objectWithoutProperties(_V, _excluded3),
      d = {
        gridArea: "1 / 2",
        minW: "2px",
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
      },
      m = {
        flex: "1 1 auto",
        display: "inline-grid",
        gridArea: "1 / 1 / 2 / 3",
        gridTemplateColumns: "0 min-content",
        color: "inherit",
        marginX: "0.125rem",
        paddingY: "0.125rem",
        visibility: i ? "hidden" : "visible",
        transform: n ? "translateZ(0)" : "",
        _after: _objectSpread({
          content: 'attr(data-value) " "',
          visibility: "hidden",
          whiteSpace: "pre",
          padding: 0
        }, d)
      },
      f = s != null && s.inputContainer ? s.inputContainer(m, e) : m,
      x = _objectSpread({
        background: 0,
        opacity: p ? 0 : 1,
        width: "100%"
      }, d),
      u = s != null && s.input ? s.input(x, e) : x;
    return jsx(Box, {
      className: o({
        "input-container": !0
      }, r),
      "data-value": n || "",
      sx: f,
      children: jsx(chakra.input, _objectSpread({
        className: o({
          input: !0
        }, l),
        ref: a,
        sx: u,
        disabled: i,
        readOnly: t ? !0 : void 0
      }, c))
    });
  },
  ee = we;
var ke = function ke(e) {
    return e ? {
      bottom: "top",
      top: "bottom"
    }[e] : "top";
  },
  Ae = function Ae(e) {
    var r = e.className,
      o = e.cx,
      n = e.children,
      s = e.innerProps,
      t = e.innerRef,
      a = e.placement,
      i = e.selectProps.chakraStyles,
      p = _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        position: "absolute"
      }, ke(a), "100%"), "marginY", "8px"), "width", "100%"), "zIndex", 1),
      l = i != null && i.menu ? i.menu(p, e) : p;
    return jsx(Menu, {
      children: jsx(Box, _objectSpread(_objectSpread({}, s), {}, {
        ref: t,
        className: o({
          menu: !0
        }, r),
        sx: l,
        children: n
      }))
    });
  },
  oe = Ae,
  ne = function ne(e) {
    var I;
    var r = e.className,
      o = e.cx,
      n = e.innerRef,
      s = e.children,
      t = e.maxHeight,
      a = e.isMulti,
      i = e.innerProps,
      _e$selectProps8 = e.selectProps,
      p = _e$selectProps8.chakraStyles,
      l = _e$selectProps8.size,
      c = _e$selectProps8.variant,
      d = _e$selectProps8.focusBorderColor,
      m = _e$selectProps8.errorBorderColor,
      f = useMultiStyleConfig("Menu"),
      x = O(l),
      S = useMultiStyleConfig("Input", {
        size: x,
        variant: c,
        focusBorderColor: d,
        errorBorderColor: m
      }).field,
      b = _objectSpread(_objectSpread({}, f.list), {}, {
        minW: "100%",
        maxHeight: "".concat(t, "px"),
        overflowY: "auto",
        "--input-border-radius": S == null ? void 0 : S["--input-border-radius"],
        borderRadius: (S == null ? void 0 : S.borderRadius) || ((I = f.list) == null ? void 0 : I.borderRadius),
        position: "relative",
        WebkitOverflowScrolling: "touch"
      }),
      g = p != null && p.menuList ? p.menuList(b, e) : b;
    return jsx(Box, _objectSpread(_objectSpread({}, i), {}, {
      className: o({
        "menu-list": !0,
        "menu-list--is-multi": a
      }, r),
      sx: g,
      ref: n,
      children: s
    }));
  },
  re = function re(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.innerProps,
      _e$selectProps9 = e.selectProps,
      t = _e$selectProps9.chakraStyles,
      a = _e$selectProps9.size,
      i = O(a),
      l = {
        color: "chakra-subtle-text",
        textAlign: "center",
        paddingY: {
          sm: "6px",
          md: "8px",
          lg: "10px"
        }[i],
        fontSize: i
      },
      c = t != null && t.loadingMessage ? t.loadingMessage(l, e) : l;
    return jsx(Box, _objectSpread(_objectSpread({}, s), {}, {
      className: n({
        "menu-notice": !0,
        "menu-notice--loading": !0
      }, o),
      sx: c,
      children: r
    }));
  },
  se = function se(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.innerProps,
      _e$selectProps10 = e.selectProps,
      t = _e$selectProps10.chakraStyles,
      a = _e$selectProps10.size,
      i = O(a),
      l = {
        color: "chakra-subtle-text",
        textAlign: "center",
        paddingY: {
          sm: "6px",
          md: "8px",
          lg: "10px"
        }[i],
        fontSize: i
      },
      c = t != null && t.noOptionsMessage ? t.noOptionsMessage(l, e) : l;
    return jsx(Box, _objectSpread(_objectSpread({}, s), {}, {
      className: n({
        "menu-notice": !0,
        "menu-notice--no-options": !0
      }, o),
      sx: c,
      children: r
    }));
  },
  ie = function ie(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.theme,
      t = e.getStyles,
      a = e.Heading,
      i = e.headingProps,
      p = e.label,
      l = e.selectProps,
      c = e.innerProps,
      d = e.getClassNames,
      m = l.chakraStyles,
      f = {},
      x = m != null && m.group ? m.group(f, e) : f;
    return jsxs(Box, _objectSpread(_objectSpread({}, c), {}, {
      className: n({
        group: !0
      }, o),
      sx: x,
      children: [jsx(a, _objectSpread(_objectSpread({}, i), {}, {
        selectProps: l,
        cx: n,
        theme: s,
        getStyles: t,
        getClassNames: d,
        children: p
      })), jsx(Box, {
        children: r
      })]
    }));
  },
  ae = function ae(e) {
    var r = e.cx,
      o = e.className,
      _e$selectProps11 = e.selectProps,
      n = _e$selectProps11.chakraStyles,
      s = _e$selectProps11.size,
      t = _e$selectProps11.hasStickyGroupHeaders,
      _V2 = V(e),
      a = _V2.data,
      i = _objectWithoutProperties(_V2, _excluded4),
      p = useMultiStyleConfig("Menu"),
      l = O(s),
      c = {
        sm: "xs",
        md: "sm",
        lg: "md"
      },
      d = {
        sm: "0.4rem 0.8rem",
        md: "0.5rem 1rem",
        lg: "0.6rem 1.2rem"
      },
      m = _objectSpread(_objectSpread({}, p.groupTitle), {}, {
        fontSize: c[l],
        padding: d[l],
        margin: 0,
        borderBottomWidth: t ? "1px" : 0,
        position: t ? "sticky" : "static",
        top: -2,
        bg: p.list.bg,
        zIndex: 1
      }),
      f = n != null && n.groupHeading ? n.groupHeading(m, e) : m;
    return jsx(Box, _objectSpread(_objectSpread({}, i), {}, {
      className: r({
        "group-heading": !0
      }, o),
      sx: f
    }));
  },
  je = function je(e) {
    return jsx("svg", _objectSpread(_objectSpread({
      viewBox: "0 0 14 14",
      width: "1em",
      height: "1em"
    }, e), {}, {
      children: jsx("polygon", {
        fill: "currentColor",
        points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
      })
    }));
  },
  le = function le(e) {
    var r = e.className,
      o = e.cx,
      n = e.innerRef,
      s = e.innerProps,
      t = e.children,
      a = e.isFocused,
      i = e.isDisabled,
      p = e.isSelected,
      _e$selectProps12 = e.selectProps,
      l = _e$selectProps12.chakraStyles,
      c = _e$selectProps12.size,
      d = _e$selectProps12.isMulti,
      m = _e$selectProps12.hideSelectedOptions,
      f = _e$selectProps12.selectedOptionStyle,
      x = _e$selectProps12.selectedOptionColorScheme,
      u = useMultiStyleConfig("Menu").item,
      S = O(c),
      b = {
        sm: "0.6rem",
        md: "0.8rem",
        lg: "1rem"
      },
      g = {
        sm: "0.3rem",
        md: "0.4rem",
        lg: "0.5rem"
      },
      I = useColorModeValue("".concat(x, ".500"), "".concat(x, ".300")),
      M = useColorModeValue("white", "black"),
      C = f === "check" && (!d || m === !1),
      B = f === "color",
      v = _objectSpread(_objectSpread({}, u), {}, {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        width: "100%",
        textAlign: "start",
        fontSize: S,
        paddingX: b[S],
        paddingY: g[S]
      }, B && {
        _selected: {
          bg: I,
          color: M,
          _active: {
            bg: I
          }
        }
      }),
      y = l != null && l.option ? l.option(v, e) : v;
    return jsxs(Box, _objectSpread(_objectSpread({}, s), {}, {
      className: o({
        option: !0,
        "option--is-disabled": i,
        "option--is-focused": a,
        "option--is-selected": p
      }, r),
      sx: y,
      ref: n,
      "data-focus": a ? !0 : void 0,
      "aria-disabled": i ? !0 : void 0,
      "aria-selected": p,
      children: [C && jsx(MenuIcon, {
        fontSize: "0.8em",
        marginEnd: "0.75rem",
        opacity: p ? 1 : 0,
        children: jsx(je, {})
      }), t]
    }));
  };
var De = function De(e) {
    return _typeof(e) == "object" && e !== null && "colorScheme" in e && typeof e.colorScheme == "string";
  },
  He = function He(e) {
    return _typeof(e) == "object" && e !== null && "variant" in e && typeof e.variant == "string";
  },
  ue = function ue(e) {
    return _typeof(e) == "object" && e !== null && "isFixed" in e && typeof e.isFixed == "boolean";
  },
  Ee = function Ee(e) {
    var r = e.children,
      o = e.className,
      n = e.components,
      s = e.cx,
      t = e.data,
      a = e.innerProps,
      i = e.isDisabled,
      p = e.isFocused,
      l = e.removeProps,
      c = e.selectProps,
      d = e.cropWithEllipsis,
      m = n.Container,
      f = n.Label,
      x = n.Remove,
      u = c.chakraStyles,
      S = c.colorScheme,
      b = c.tagVariant,
      g = c.size,
      I = O(g),
      M = "",
      C = "",
      B = !1;
    De(t) && (M = t.colorScheme), He(t) && (C = t.variant), ue(t) && (B = t.isFixed);
    var v = useMultiStyleConfig("Tag", {
        size: I,
        colorScheme: M || S,
        variant: C || b || (B ? "solid" : "subtle")
      }),
      y = _objectSpread(_objectSpread({}, v.container), {}, {
        display: "flex",
        alignItems: "center",
        minWidth: 0,
        margin: "0.125rem"
      }),
      A = u != null && u.multiValue ? u.multiValue(y, e) : y,
      N = _objectSpread(_objectSpread({}, v.label), {}, {
        overflow: "hidden",
        textOverflow: d || d === void 0 ? "ellipsis" : void 0,
        whiteSpace: "nowrap"
      }),
      D = u != null && u.multiValueLabel ? u.multiValueLabel(N, e) : N,
      w = _objectSpread(_objectSpread({}, v.closeButton), {}, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }),
      H = u != null && u.multiValueRemove ? u.multiValueRemove(w, e) : w;
    return jsxs(m, {
      data: t,
      innerProps: _objectSpread({
        className: s({
          "multi-value": !0,
          "multi-value--is-disabled": i
        }, o)
      }, a),
      sx: A,
      selectProps: c,
      children: [jsx(f, {
        data: t,
        innerProps: {
          className: s({
            "multi-value__label": !0
          }, o)
        },
        sx: D,
        selectProps: c,
        children: r
      }), jsx(x, {
        data: t,
        innerProps: _objectSpread({
          className: s({
            "multi-value__remove": !0
          }, o),
          "aria-label": "Remove ".concat(r || "option")
        }, l),
        sx: H,
        selectProps: c,
        isFocused: p
      })]
    });
  },
  de = function de(e) {
    var r = e.children,
      o = e.innerProps,
      n = e.sx;
    return jsx(chakra.span, _objectSpread(_objectSpread({}, o), {}, {
      sx: n,
      children: r
    }));
  },
  me = function me(e) {
    var r = e.children,
      o = e.innerProps,
      n = e.sx;
    return jsx(chakra.span, _objectSpread(_objectSpread({}, o), {}, {
      sx: n,
      children: r
    }));
  },
  We = function We(e) {
    return jsx(Icon, _objectSpread(_objectSpread({
      verticalAlign: "inherit",
      viewBox: "0 0 512 512"
    }, e), {}, {
      children: jsx("path", {
        fill: "currentColor",
        d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
      })
    }));
  },
  xe = function xe(e) {
    var r = e.children,
      o = e.innerProps,
      n = e.isFocused,
      s = e.data,
      t = e.sx;
    return ue(s) && s.isFixed ? null : jsx(Box, _objectSpread(_objectSpread({}, o), {}, {
      role: "button",
      sx: t,
      "data-focus": n ? !0 : void 0,
      "data-focus-visible": n ? !0 : void 0,
      children: r || jsx(We, {})
    }));
  };
var fe = Ee;
var Xe = function Xe(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.innerProps,
      t = e.selectProps.chakraStyles,
      a = {
        gridArea: "1 / 1 / 2 / 3",
        color: "chakra-placeholder-color",
        mx: "0.125rem",
        userSelect: "none"
      },
      i = t != null && t.placeholder ? t.placeholder(a, e) : a;
    return jsx(Box, _objectSpread(_objectSpread({}, s), {}, {
      className: n({
        placeholder: !0
      }, o),
      sx: i,
      children: r
    }));
  },
  Se = Xe;
var Je = function Je(e) {
    var r = e.children,
      o = e.className,
      n = e.cx,
      s = e.isDisabled,
      t = e.innerProps,
      a = e.selectProps.chakraStyles,
      i = {
        gridArea: "1 / 1 / 2 / 3",
        mx: "0.125rem",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      },
      p = a != null && a.singleValue ? a.singleValue(i, e) : i;
    return jsx(Box, _objectSpread(_objectSpread({
      className: n({
        "single-value": !0,
        "single-value--is-disabled": s
      }, o),
      sx: p
    }, t), {}, {
      children: r
    }));
  },
  Oe = Je;
var Qe = {
    ClearIndicator: K,
    Control: U,
    DropdownIndicator: J,
    Group: ie,
    GroupHeading: ae,
    IndicatorSeparator: Z,
    IndicatorsContainer: _,
    Input: ee,
    LoadingIndicator: Q,
    LoadingMessage: re,
    Menu: oe,
    MenuList: ne,
    MultiValue: fe,
    MultiValueContainer: de,
    MultiValueLabel: me,
    MultiValueRemove: xe,
    NoOptionsMessage: se,
    Option: le,
    Placeholder: Se,
    SelectContainer: W,
    SingleValue: Oe,
    ValueContainer: Y
  },
  F = Qe;
var et = function et(_ref) {
    var _ref$components = _ref.components,
      e = _ref$components === void 0 ? {} : _ref$components,
      r = _ref.theme,
      o = _ref.size,
      _ref$colorScheme = _ref.colorScheme,
      n = _ref$colorScheme === void 0 ? "gray" : _ref$colorScheme,
      s = _ref.isDisabled,
      t = _ref.isInvalid,
      a = _ref.isReadOnly,
      i = _ref.required,
      p = _ref.isRequired,
      l = _ref.inputId,
      c = _ref.tagVariant,
      _ref$selectedOptionSt = _ref.selectedOptionStyle,
      d = _ref$selectedOptionSt === void 0 ? "color" : _ref$selectedOptionSt,
      m = _ref.selectedOptionColorScheme,
      f = _ref.selectedOptionColor,
      x = _ref.variant,
      u = _ref.focusBorderColor,
      S = _ref.errorBorderColor,
      _ref$chakraStyles = _ref.chakraStyles,
      b = _ref$chakraStyles === void 0 ? {} : _ref$chakraStyles,
      g = _ref.onFocus,
      I = _ref.onBlur,
      M = _ref.menuIsOpen,
      C = _objectWithoutProperties(_ref, _excluded5);
    var E;
    var B = useTheme(),
      v = B.components.Input.defaultProps.variant,
      y = useFormControl({
        id: l,
        isDisabled: s,
        isInvalid: t,
        isRequired: p,
        isReadOnly: a,
        onFocus: g,
        onBlur: I
      }),
      A = M != null ? M : y.readOnly ? !1 : void 0,
      N = d;
    ["color", "check"].includes(d) || (N = "color");
    var w = m || f || "blue";
    return typeof w != "string" && (w = "blue"), _objectSpread(_objectSpread({
      components: _objectSpread(_objectSpread({}, F), e),
      colorScheme: n,
      size: o,
      tagVariant: c,
      selectedOptionStyle: N,
      selectedOptionColorScheme: w,
      variant: x != null ? x : v,
      chakraStyles: b,
      focusBorderColor: u,
      errorBorderColor: S,
      onFocus: y.onFocus,
      onBlur: y.onBlur,
      isDisabled: y.disabled,
      isInvalid: !!y["aria-invalid"],
      inputId: y.id,
      isReadOnly: y.readOnly,
      required: i != null ? i : y.required,
      menuIsOpen: A
    }, C), {}, {
      "aria-invalid": (E = C["aria-invalid"]) != null ? E : y["aria-invalid"]
    });
  },
  h = et;
var nt = forwardRef(function (e, r) {
    var o = h(e);
    return jsx(ot__default, _objectSpread({
      ref: r
    }, o));
  }),
  rt = nt;
var lt = forwardRef(function (e, r) {
    var o = h(e);
    return jsx(at, _objectSpread({
      ref: r
    }, o));
  }),
  pt = lt;
var mt = forwardRef(function (e, r) {
    var o = h(e);
    return jsx(dt, _objectSpread({
      ref: r
    }, o));
  }),
  xt = mt;
var yt = forwardRef(function (e, r) {
    var o = h(e);
    return jsx(Ot, _objectSpread({
      ref: r
    }, o));
  }),
  bt = yt;
export { bt as AsyncCreatableSelect, xt as AsyncSelect, pt as CreatableSelect, rt as Select, F as chakraComponents, h as useChakraSelectProps };